import { useEffect } from 'react';

import { useAnalyticsContext } from '../../../modules/analytics/AnalyticsContext';

export default (error: string | undefined) => {
  const {
    analytics: { trackLink },
  } = useAnalyticsContext();

  useEffect(() => {
    if (!error) {
      return;
    }

    trackLink({
      eventName: 'alert_viewed',
      alertShownType: 'error',
      alertShownMessage: error,
    });
  }, [trackLink, error]);
};
